import { render, staticRenderFns } from "./ModalActivitice.vue?vue&type=template&id=6a7e0003&"
import script from "./ModalActivitice.vue?vue&type=script&lang=js&"
export * from "./ModalActivitice.vue?vue&type=script&lang=js&"
import style0 from "./ModalActivitice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports